import type { AccessCountByDay, RegistrationCountByDay } from "./analytics.interfaces";
import type { IAnalyticsService } from "./analytics.service";

export class AnalyticsMockService implements IAnalyticsService {
  async getAccessesByDay(_from: string, _to: string): Promise<AccessCountByDay[]> {
    return [];
  }

  async getRegistrationsByDay(_from: string, _to: string): Promise<RegistrationCountByDay[]> {
    return [];
  }
}
